import { Container, Graphics } from "pixi.js";
import { indoor, windows } from "./common.js";

/** UBEP: bienestar estudiantil. Recepción, avisos y sala de espera. */
export function ubep(): Container {
  const scene = indoor({ wall: 0xeaf2ec, floor: 0xc8d2cb, skirting: 0x9db3a6 });

  windows(scene, 2, 60, 0xb7e0c6);

  // Mural de avisos: es lo que hace que una recepción se lea como bienestar.
  const board = new Graphics();
  board.rect(360, 70, 260, 130).fill(0xe4d3a8).stroke({ width: 6, color: 0x9c7a42 });
  const notes = [0xf4f7fa, 0xffe08a, 0xbfe3f2, 0xf7c6c6];
  for (let i = 0; i < 6; i++) {
    board
      .rect(380 + (i % 3) * 80, 92 + Math.floor(i / 3) * 56, 62, 44)
      .fill(notes[i % notes.length]!)
      .stroke({ width: 2, color: 0x9c7a42 });
  }
  scene.addChild(board);

  const cross = new Graphics();
  cross.rect(760, 96, 90, 90).fill(0xf4f7fa).stroke({ width: 4, color: 0x2f9e63 });
  cross.rect(790, 110, 30, 62).fill(0x2f9e63);
  cross.rect(774, 126, 62, 30).fill(0x2f9e63);
  scene.addChild(cross);

  return scene;
}
